import { MapContainer, TileLayer } from "react-leaflet";
import { Card, CardBody, Col } from "reactstrap";
import { IndiaMapTitle } from "../../../../constants";
import { IndiaMapProps, IndiaMapSubHeading } from "../../../../data/miscellaneous/Maps";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const IndiaMap = () => {
  return (
    <Col sm="6">
      <Card>
        <CommonCardHeader title={IndiaMapTitle} span={IndiaMapSubHeading} />
        <CardBody className="map-z-index">
          <MapContainer className="jvector-map-height custom-map" {...IndiaMapProps}>
            <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
          </MapContainer>
        </CardBody>
      </Card>
    </Col>
  );
};
export default IndiaMap;
